import { combineReducers } from "redux";
import { appPhuHuynhReducerWrapper } from './app-phuhuynh/appPhuHuynhReducerWrapper';
import { authReducer } from "./authReducer";
import { baiTapReducerWrapper } from './bai-tap/baiTapReducerWrapper';
import { baiVietDetailReducer } from './bai-viet/baiVietDetailReducer';
import { baiVietReducer } from './bai-viet/baiVietReducer';
import { baiVietTrangThaiReducer } from './bai-viet/baiVietTrangThaiReducer';
import { categorySourceReducer } from "./categorySourceReducer";
import { commonReducer } from "./commonReducer";
import { dgdkHocTapReducer } from './danh-gia/dinh-ky/dgdkHocTapReducer';
import { dgdkNlpcReducer } from './danh-gia/dinh-ky/dgdkNlpcReducer';
import { dgtxKetQuaMonHocReducer } from './danh-gia/thuong-xuyen/dgtxKetQuaMonHocReducer';
import { dgtxKetQuaReducer } from './danh-gia/thuong-xuyen/dgtxKetQuaReducer';
import { danhMucReducerWrapper } from './danh-muc/danhMucReducerWrapper';
import { giaoVienNhanXetReducer } from './danh-muc/giaoVienNhanXetReducer';
import { giaoVienReducer } from "./danh-muc/giaoVienReducer";
import { monHocReducer } from "./danh-muc/monHocReducer";
import { toKhoiReducer } from "./danh-muc/toKhoiReducer";
import { dictionaryReducer } from "./dictionaryReducer";
import { diemDanhReducer } from './diem-danh/diemDanhReducer';
import { diemDanhStatusReducer } from './diem-danh/diemDanhStatusReducer';
import { localizedResourceReducer } from './localized-resource/localizedResourceReducer';
import { lopBoMonReducer } from './lop-bo-mon/lopBoMonReducer';
import { lopChuNhiemReducer } from './lop-chu-nhiem/lopChuNhiemReducer';
import { lopHanhChinhSoDiemReducer } from './lop-hanh-chinh/lopHanhChinhSoDiemReducer';
import { mappingReducer } from './mapping/mappingReducer';
import { nhanXetHangNgayReducer } from './nhan-xet/nhanXetHangNgayReducer';
import { thaiDoHocTapReducer } from './nhan-xet/thaiDoHocTapReducer';
import { thaiDoHocTapTieuChiReducer } from './nhan-xet/thaiDoHocTapTieuChiReducer';
import { nhapDiemReducer } from './nhap-diem/nhapDiemReducer';
import { notifyReducer } from './notify/notifyReducer';
import { loaiPhongReducer } from './phong-hoc/loaiPhongReducer';
import { phongHocReducer } from './phong-hoc/phongHocReducer';
import { soNhanXetReducer } from './so-diem-tieu-hoc/dinh-ky/soNhanXetReducer';
import { soNhanXetItemReducer } from './so-diem-tieu-hoc/soNhanXetItemReducer';
import { monHocSoDiemReducer } from './so-diem/monHocSoDiemReducer';
import { soDiemReducerWrapper } from './so-diem/soDiemReducerWrapper';
import { thoiKhoaBieuReducerWrapper } from './thoi-khoa-bieu/thoiKhoaBieuReducerWrapper';
import { thoiKhoaBieuViewReducer } from './thoi-khoa-bieu/thoiKhoaBieuViewReducer';
import { uploadReducer } from './upload-file/uploadReducer';

import { baiVietCommentReducer } from "./bai-viet-comment/baiVietCommentReducer";
import { baoCaoTienBoReducer } from './bao-cao-tien-bo/baoCaoTienBoReducer';
import { chamTietLoaiTietReducer } from './cham-tiet/chamTietLoaiTietReducer';
import { chamTietReducer } from './cham-tiet/chamTietReducer';
import { appConfigReducer } from "./common/appConfigReducer";
import { nguonBietToiReducer } from './crm-category/nguonBietToiReducer';
import { nguonBietToiTypeReducer } from './crm-category/nguonBietToiTypeReducer';
import { crmHocSinhReducer } from './crm-hocsinh/crmHocSinhReducer';
import { chienDichReducer } from './crm-survey/chienDichReducer';
import { crmSurveyFormQuestionReducer } from './crm-survey/crmSurveyFormQuestionReducer';
import { crmSurveyFormReducer } from './crm-survey/crmSurveyFormReducer';
import { ychtGroupReducer } from './danh-muc/ychtGroupReducer';
import { diemVanMinhKetQuaReducer } from './diemvanminh-ketqua/diemVanMinhKetQuaReducer';
import { diemVanMinhTieuChiReducer } from './diemvanminh-tieuchi/diemVanMinhTieuChiReducer';
import { dmEmailConfigReducer } from './email/dmEmailConfigReducer';
import { emailTemplateReducer } from './email/emailTemplateReducer';
import { formEditorReducer } from './form/formEditorReducer';
import { formEditorTypeReducer } from './form/formEditorTypeReducer';
import { formItemReducer } from './form/formItemReducer';
import { formReducer } from './form/formReducer';
import { formRegisterResultReducer } from './form/formRegisterResultReducer';
import { lopMonHocReducer } from './lop-mon-hoc/lopMonHocReducer';
import { foCaAnReducer } from "./thuc-don/foCaAnReducer";
import { foCaAnTruongReducer } from "./thuc-don/foCaAnTruongReducer";
import { foMonAnChiTietReducer } from "./thuc-don/foMonAnChiTietReducer";
import { foThucDonReducer } from "./thuc-don/foThucDonReducer";
import { tongHopDinhKyReducer } from "./tong-hop/tongHopDinhKyReducer";
import { TRANG_THAI_HOC_SINHReducer } from './trang-thai-hoc-sinh/trangThaiHocSInhReducer';
import { TRANG_THAI_PHU_HUYNHReducer } from './trang-thai-phu-huynh/trangThaiPhuHuynhReducer';
import { crmPhuHuynhReducer } from "./crm-phuhuynh/crmPhuHuynhReducer";
import { emailFormReducer } from "./email/emailFormReducer";
import { loaiSucKhoeReducer } from "./danh-muc/loaiSucKhoeReducer";
import { sucKhoeReducer } from "./danh-muc/sucKhoeReducer";
import { hocSinhAceReducer } from "./crm-hocsinh/hocSinhAceReducer";
import { hocSinhAceChiTietReducer } from "./crm-hocsinh/hocSinhAceChiTietReducer";
import { thongTinCbnvReducer } from "./thongtin-cbnv/thongTinCbnvReducer";
import { conCbnvReducer } from "./con-cbnv/conCbnvReduder";
import { boDoiCongAnReducer } from "./bodoi-congan/boDoiCongAnReducer";
const reducers = combineReducers({
    auth: authReducer,
    appConfig: appConfigReducer,
    appPhuHuynhWrapper: appPhuHuynhReducerWrapper,
    dictionary: dictionaryReducer,
    categorySource: categorySourceReducer,
    common: commonReducer,
    monHoc: monHocReducer,
    ychtGroupReducer,
    lopBoMon: lopBoMonReducer,
    soDiem: soDiemReducerWrapper,
    toKhoi: toKhoiReducer,
    giaoVien: giaoVienReducer,
    soNhanXet: soNhanXetReducer,
    soNhanXetItem: soNhanXetItemReducer,
    giaoVienNhanXet: giaoVienNhanXetReducer,
    loaiPhong: loaiPhongReducer,
    phongHoc: phongHocReducer,
    thoiKhoaBieuWrapper: thoiKhoaBieuReducerWrapper,
    danhMucWrapper: danhMucReducerWrapper,
    uploadFile: uploadReducer,
    baiViet: baiVietReducer,
    baiVietTrangThai: baiVietTrangThaiReducer,
    baiVietDetail: baiVietDetailReducer,
    notify: notifyReducer,
    diemDanh: diemDanhReducer,
    diemDanhStatus: diemDanhStatusReducer,
    nhanXetHangNgay: nhanXetHangNgayReducer,
    localizedResource: localizedResourceReducer,
    baiTapWrapper: baiTapReducerWrapper,
    nhapDiem: nhapDiemReducer,
    monHocSoDiem: monHocSoDiemReducer,
    lopChuNhiem: lopChuNhiemReducer,
    mapping: mappingReducer,
    thaiDoHocTapWrapper: combineReducers({
        thaiDoHocTap: thaiDoHocTapReducer,
        thaiDoHocTapTieuChi: thaiDoHocTapTieuChiReducer
    }),
    diemVanMinhTieuChi: diemVanMinhTieuChiReducer,
    diemVanMinhKetQua: diemVanMinhKetQuaReducer,
    dgdkNlpc: dgdkNlpcReducer,
    dgtxKetQua: dgtxKetQuaReducer,
    dgdkHocTap: dgdkHocTapReducer,
    dgtxKetQuaMonHoc: dgtxKetQuaMonHocReducer,
    lopHanhChinhSoDiem: lopHanhChinhSoDiemReducer,
    baoCaoTienBo: baoCaoTienBoReducer,
    lopMonHoc: lopMonHocReducer,
    tongHop: combineReducers({
        dinhKy: tongHopDinhKyReducer
    }),
    baiVietComment: baiVietCommentReducer,
    thoiKhoaBieuView: thoiKhoaBieuViewReducer,
    chamTietLoaiTiet: chamTietLoaiTietReducer,
    chamTiet: chamTietReducer,
    trangThaiHocSinh: TRANG_THAI_HOC_SINHReducer,
    trangThaiPhuHuynh: TRANG_THAI_PHU_HUYNHReducer,
    formWrapper: combineReducers({
        form: formReducer,
        formItem: formItemReducer,
        formEditorType: formEditorTypeReducer,
        formEditor: formEditorReducer,
        formRegisterResult: formRegisterResultReducer,
    }),
    crmSurvey: combineReducers({
        crmSurveyFormQuestion: crmSurveyFormQuestionReducer,
        crmSurveyForm: crmSurveyFormReducer,
        chienDich: chienDichReducer

    }),
    crmCategoryWrapper: combineReducers({
        nguonBietToi: nguonBietToiReducer,
        nguonBietToiType: nguonBietToiTypeReducer,

    }),
    email: combineReducers({
        dmEmailConfig: dmEmailConfigReducer,
        template: emailTemplateReducer,
        form: emailFormReducer

    }),
    crmHocSinh: crmHocSinhReducer,
    thucDonWrapper: combineReducers({
        caAn: foCaAnReducer,
        caAnTruong: foCaAnTruongReducer,
        monAnChiTiet: foMonAnChiTietReducer,
        thucDon: foThucDonReducer
    }),
    crmPhuHuynh: crmPhuHuynhReducer,
    sucKhoe: combineReducers({
        sucKhoe: sucKhoeReducer,
        loaiSucKhoe: loaiSucKhoeReducer

    }),
    hocSinhAce:hocSinhAceReducer,
    hocSinhAceChiTiet:hocSinhAceChiTietReducer,
    thongTinCbnv:thongTinCbnvReducer,
    conCbnv:conCbnvReducer,
    boDoiCongAn:boDoiCongAnReducer


})

export default reducers

export type RootState = ReturnType<typeof reducers>